// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.g3TS5r1szo8XTLyFQMUz{flex-direction:column;flex-grow:1;gap:32px;padding:16px 24px 24px;display:flex}.HgFkNOPVOXgjbalGz6K9{flex-grow:1;align-content:flex-end;padding-right:24px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `g3TS5r1szo8XTLyFQMUz`,
	"footer": `HgFkNOPVOXgjbalGz6K9`
};
export default ___CSS_LOADER_EXPORT___;
